import axios from 'axios';
import { isProd } from '../env/environment';

// Pacy's own backend API
export const api = axios.create({
    baseURL: isProd() ? 'https://api.pacy.ai': 'https://api.dev.pacy.ai',
    headers: {
        'Content-Type': 'application/json'
    }
});